import { computed, get } from '@ember/object';

export default function ternaryToProperty(dependentKey, positiveKey, negativeKey) {
  return computed(dependentKey, positiveKey, negativeKey, function () {
    return get(this, dependentKey) ? get(this, positiveKey) : get(this, negativeKey);
  });
}
